<mdb-loading [show]="loading" [fullscreen]="true">
  <div class="loading-spinner" role="status" aria-live="polite" aria-label="Loading">
    <!-- <div class="spinner-border loading-icon" role="status"></div> -->
    <div><img src="assets/images/loading.gif" alt="" height="100" width="100" /></div>
    <span class="loading-text" aria-hidden="true">Loading...</span>
  </div>
</mdb-loading>
